import * as React from 'react';
import { Button, Stack, Tooltip, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import {
  CheckoutFormValues,
  CheckoutPaymentMethod,
} from '../../types/appointments';
import { Appointment } from '../../interfaces';
import { isAppointmentDepositPaid } from '../../helpers/appointments';
import PaymentMethodsList from '../checkout/PaymentMethodsList';
import { DEFAULT_TOOLTIP_PROPS } from '../../constants/ui';

interface Props {
  enabledPaymentMethods: CheckoutPaymentMethod[];
  selectedAppointment?: Appointment | null;
  totalDue: number;
  onSplitPayment: () => void;
}

export default function PaymentMethod({
  enabledPaymentMethods,
  selectedAppointment,
  totalDue,
  onSplitPayment,
}: Props) {
  const { values, setFieldValue } = useFormikContext<CheckoutFormValues>();

  const isDepositPaid = React.useMemo(
    () => isAppointmentDepositPaid(selectedAppointment),
    [selectedAppointment],
  );

  return (
    <div className="input-group">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="end"
        width="100%">
        <Typography variant="h2">Payment Method</Typography>
        <Tooltip
          {...DEFAULT_TOOLTIP_PROPS}
          title={
            !values.customer?.phoneNumber
              ? 'Please select a customer to split payment'
              : undefined
          }>
          <span>
            <Button
              variant="light"
              color="info"
              onClick={() => onSplitPayment()}
              disabled={!values.customer?.phoneNumber || totalDue <= 0}>
              Split Payment
            </Button>
          </span>
        </Tooltip>
      </Stack>
      <PaymentMethodsList
        paymentMethods={enabledPaymentMethods}
        selectedPaymentMethod={values.paymentMethod}
        onChange={async value => {
          if (value === 'FREE' && values.customOrderItems?.length) {
            setFieldValue('customOrderItems', []);
          }

          setFieldValue('paymentMethod', value);
          if (value === 'FREE') {
            const newPrice = isDepositPaid
              ? selectedAppointment?.depositPrice
              : 0;
            setFieldValue('price', newPrice || 0);
            setFieldValue('tipAmt', 0);
            // set it back to original price if previous is FREE
          } else if (values.paymentMethod === 'FREE') {
            setFieldValue('price', selectedAppointment?.price ?? 0);
          }
        }}
      />
    </div>
  );
}
